module.exports = __webpack_public_path__ + "img/card-accepted-brands.2ab8f2e1.jpg";